import { TableColumnMeta } from "ds/components/Table/types";

import { ENV_VARS_COLUMNS, EnvVariablesColumnId } from "./envVariableTable";
import { ACTIONS_COLUMN_CONFIG } from "./globalTable";

export type SpaceliftVarsColumnId =
  | EnvVariablesColumnId.NAME
  | EnvVariablesColumnId.DESCRIPTION
  | EnvVariablesColumnId.VALUE
  | EnvVariablesColumnId.ACTIONS;

export const SPACELIFT_VARS_COLUMNS_STORAGE_KEY = "environmentSpaceliftVariablesColumnsConfig";

export const SPACELIFT_VARS_COLUMNS: Record<SpaceliftVarsColumnId, TableColumnMeta> = {
  [EnvVariablesColumnId.NAME]: ENV_VARS_COLUMNS[EnvVariablesColumnId.NAME],
  [EnvVariablesColumnId.DESCRIPTION]: ENV_VARS_COLUMNS[EnvVariablesColumnId.DESCRIPTION],
  [EnvVariablesColumnId.VALUE]: ENV_VARS_COLUMNS[EnvVariablesColumnId.VALUE],
  [EnvVariablesColumnId.ACTIONS]: ACTIONS_COLUMN_CONFIG,
};
